import domReady from '@wordpress/dom-ready';
import { generateScrollSteps } from './utils';

domReady( () => {
	( function ( $ ) {
		$( window ).on( 'load', function () {
			const tabs = $( '.wp-block-do-blocks-tabs' );

			tabs.each( function () {
				const height = $( this ).height();
				const stepsLength = parseInt( $( this ).data( 'tabs-length' ) );
				const isScrollable = $( this ).data( 'tabs-scrollable' );
				const scrollSteps = generateScrollSteps( stepsLength );
				const tabButtons = $( this ).find(
					'.wp-block-do-blocks-tab-button'
				);
				const tabContents = $( this ).find(
					'.wp-block-do-blocks-tab-content'
				);

				$( tabButtons[ 0 ] ).addClass( 'active' );
				$( tabContents[ 0 ] ).addClass( 'active' );

				tabButtons.each( function ( index ) {
					$( this ).on( 'click', function () {
						if ( isScrollable ) {
							window.removeEventListener(
								'scroll',
								scrollRefFunc
							);
							const scrollPositionCalc =
								( 100 / stepsLength ) * index;
							const id = $( this ).attr( 'href' );

							$( id ).css( {
								top: `${ scrollPositionCalc }%`,
							} );
						}

						tabButtons.each( function ( i, ele ) {
							$( ele ).removeClass( 'active' );
						} );
						tabContents.each( function ( i, ele ) {
							$( ele ).removeClass( 'active' );
						} );
						$( this ).addClass( 'active' );
						$( tabContents[ index ] ).addClass( 'active' );

						if ( isScrollable ) {
							setTimeout( () => {
								window.addEventListener(
									'scroll',
									scrollRefFunc
								);
							}, 1000 );
						}
					} );
				} );

				const scrollRefFunc = () => {
					if ( window.scrollY > $( this ).offset().top ) {
						const getTopScroll =
							window.scrollY - $( this ).offset().top;
						const percent = Math.ceil(
							( getTopScroll / height ) * 100
						);

						scrollSteps.forEach( ( ele, index ) => {
							if ( percent >= ele ) {
								tabButtons.each( function ( i, item ) {
									$( item ).removeClass( 'active' );
								} );
								tabContents.each( function ( i, item ) {
									$( item ).removeClass( 'active' );
								} );
								$( tabButtons[ index ] ).addClass( 'active' );
								$( tabContents[ index ] ).addClass( 'active' );
							}
						} );
					}
				};

				if ( isScrollable ) {
					window.addEventListener( 'scroll', scrollRefFunc );
				}
			} );
		} );

		// eslint-disable-next-line no-undef
	} )( jQuery );
} );
